import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
// import routes from "../routes/routes";
import { IoMailOutline } from "react-icons/io5";
import { MdCallMade } from "react-icons/md";
import { FaLinkedinIn, FaFacebookF, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { GrLocationPin } from "react-icons/gr";
// import Buttons from "../components/Buttons";
const Footer = () => {
  return (
    <>
      <section>
        <Container fluid className="px-lg-4 px-md-5 px-sm-3 px-2 ">
          <Row>
            <Col xs="12">
              <div className="footer-bg vision_point">
                <Row>
                  <Col lg="6" className="py-3">
                    <h4 className="monts">SK Data</h4>
                    <p className="monts-regular">
                      We are here to help you with your business needs. Reach
                      out to us for any inquiries or support.
                    </p>
                    <div className="d-flex align-items-center mb-4">
                      <div className="footer-icon">
                        <FaLinkedinIn size={22} />
                      </div>
                      <div className="footer-icon">
                        <FaFacebookF size={22} />
                      </div>
                      <div className="footer-icon">
                        <FaInstagram size={22} />
                      </div>
                      <div className="footer-icon">
                        <FaXTwitter size={22} />
                      </div>
                    </div>
                  </Col>
                  <Col lg="3" xs="12" className="py-3">
                    <h5 className="monts pb-3">Email</h5>
                    <div className="d-flex align-items-center mb-4 monts-regular">
                      <div className="me-3">
                        <IoMailOutline size={22} />
                      </div>
                      <div>maharaja@skdatatech.com</div>
                    </div>
                    <div className="d-flex align-items-center mb-4 monts-regular">
                      <div className="me-3">
                        <IoMailOutline size={22} />
                      </div>
                      <div>info@skdatatech.com</div>
                    </div>
                    <div className="d-flex align-items-center mb-4 monts-regular">
                      <div className="me-3">
                        <MdCallMade size={22} />
                      </div>
                      <div>+91 95972 88226</div>
                    </div>
                  </Col>
                  <Col lg="3" xs="12" className="py-3">
                    <h5 className="monts pb-3 text-center">Our Location</h5>
                    <div className="d-flex mb-4 monts-regular">
                      <div className="me-3">
                        <GrLocationPin size={22} />
                      </div>
                      <div className="monts-regular">
                       2nd Floor, 10E/1B, Trivandrum Road, Next to Annai Grand, Vannarpettai, Tirunelveli - 627003.
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
          <footer>
        {/* Footer Content */}
        <Container>
          <Row className="text-center">
            <Col xs="12" className="py-3">
              <div className="monts-regular fs-12">
                © 2025 SK Data Tech. All rights reserved. Developed By{" "}
                <Link to="https://zentexus.com/" className="monts-regular">
                  Zentexus
                </Link>{" "}
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
      </section>
    </>
  );
};

export default Footer;
